const OnApprovalIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.425 12.6C12.425 12.85 12.225 13.05 11.975 13.05H2.77495C2.52495 13.05 2.32495 12.85 2.32495 12.6V3.4C2.32495 3.15 2.52495 2.95 2.77495 2.95H11.125L12.125 1.825C12.075 1.825 12.05 1.825 12 1.825H2.77495C1.92495 1.825 1.19995 2.525 1.19995 3.4V12.625C1.19995 13.5 1.89995 14.2 2.77495 14.2H12C12.85 14.2 13.575 13.5 13.575 12.625V3.625L12.45 4.875V12.6H12.425Z"
        fill="#FBBF24"
      />
      <path
        d="M14.4498 0.925003C14.2248 0.725003 13.8748 0.725003 13.6498 0.975003L12.7248 2L11.8748 2.95L7.09985 8.3L4.72484 6.125C4.49984 5.925 4.14984 5.925 3.92484 6.15C3.72484 6.375 3.72485 6.725 3.94985 6.95L6.74985 9.5C6.84985 9.6 6.99985 9.65 7.12485 9.65H7.14985C7.29985 9.65 7.44985 9.575 7.54985 9.475L12.4248 4.025L13.4498 2.875L14.4998 1.7C14.6998 1.475 14.6998 1.125 14.4498 0.925003Z"
        fill="#FBBF24"
      />
    </svg>
  );
};

export default OnApprovalIcon;
